"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxProgress = exports.CheckboxCondition = exports.CheckboxType = void 0;
var CheckboxType;
(function (CheckboxType) {
    CheckboxType["selfCheck"] = "selfCheck";
    CheckboxType["continue"] = "continue";
})(CheckboxType || (exports.CheckboxType = CheckboxType = {}));
var CheckboxCondition;
(function (CheckboxCondition) {
    CheckboxCondition["all"] = "all";
    CheckboxCondition["last"] = "last";
    CheckboxCondition["none"] = "none";
})(CheckboxCondition || (exports.CheckboxCondition = CheckboxCondition = {}));
var CheckboxProgress;
(function (CheckboxProgress) {
    CheckboxProgress["any"] = "any";
    CheckboxProgress["all"] = "all";
})(CheckboxProgress || (exports.CheckboxProgress = CheckboxProgress = {}));
